import { createFileRoute } from '@tanstack/react-router';

import { authErrorSearch } from '@/platform/auth/auth-error-search';
import { LoginView } from '@/platform/auth/LoginView';

export const Route = createFileRoute('/login')({
   validateSearch: authErrorSearch,
   component: LoginView
});
